/**
 * Fetch and transform trip data from an API endpoint
 * @async
 * @returns {Array<Object>} Returns a modified array of trip objects
 */
export const getCurrentTrips = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URI_TRIPS, {
            method: 'GET',
            headers: {
                'x-hasura-admin-secret': process.env.REACT_APP_API_KEY,
            }
        })
        const json = await response.json()

        const trips = json.trips

        return trips?.map(trip => ({
            // tripID: trip.trip_id.substring(0, 8),
            tripID: trip.trip_id,
            distance: trip.distance,
            monitoring: trip.monitoring,
            panic: trip.panic_button,
            tripStatus: trip.status,
            tripSubStatus: trip.substatus,
            user: `${trip.user_data.name} ${trip.user_data.last_name}`,
            driver: `${trip.driver_data.name} ${trip.driver_data.last_name}`,
            locations: {
                origin: trip.locations[0].description,
                destination: trip.locations[1].description
            }
        }))

    } catch (err) {
         console.log("🚀 ~ file: currentTrips.js:35 ~ getCurrentTrips ~ err:", err)
         throw new Error(`Error geting active trips: ${err}`) }
}